/**
 * The towns cars are collected in, as the fleet names them: a catalogue car's
 * pick-up places, a partner car's town. One entry per town whatever its case
 * or spacing, the most-served first (then alphabetical). No count is shown:
 * the list holds the fleet the page loaded, not a census.
 */
export function citiesIn(fleet) {
  const towns = new Map();
  for (const car of Array.isArray(fleet) ? fleet : []) {
    const seen = new Set();
    for (const raw of Array.isArray(car?.pickup_locations) ? car.pickup_locations : []) {
      const name = typeof raw === "string" ? raw.trim().replace(/\s+/g, " ") : "";
      const key = name.toLocaleLowerCase();
      if (!name || seen.has(key)) continue;
      seen.add(key);
      const entry = towns.get(key) || { name, cars: 0 };
      entry.cars += 1;
      towns.set(key, entry);
    }
  }
  return [...towns.values()]
    .sort((a, b) => b.cars - a.cars || a.name.localeCompare(b.name))
    .map((entry) => entry.name);
}
